import { Box } from '@mui/material';
import React from 'react';

const TabPanel = props => {
  const { children, value, index, sx, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`form-analytics-tabs-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      sx={sx}
      {...other}
    >
      {value === index && children}
    </Box>
  );
};

export default TabPanel;
